"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var industries_1 = require("../industries");
var industryConfig = {
    skillup: {
        industries: industries_1.industries,
        careerFields: industries_1.skillUpCareerFields,
        careerFieldOptions: industries_1.skillUpCareerFieldOptions,
        careerFieldMappings: industries_1.SkillUpCareerFieldMappings,
        industryOptions: industries_1.wwgIndustryOptions,
    },
    wherewego: {
        industries: industries_1.industries,
        careerFieldOptions: industries_1.wwgCareerFieldOptions,
        careerFields: industries_1.wwgCareerFields,
        careerFieldMappings: industries_1.WWGCareerFieldMappings,
        industryOptions: industries_1.wwgIndustryOptions,
    }
};
exports.default = industryConfig;
